// Email service using EmailJS or similar service
// For production, you should use a backend service or EmailJS

export const sendEmail = async ({ to, subject, body, pdfBlob, pdfFileName }) => {
  // Option 1: Using EmailJS (requires setup at https://www.emailjs.com/)
  // You'll need to install: npm install @emailjs/browser
  // And configure your EmailJS service ID, template ID, and public key
  
  // Option 2: Using a backend API endpoint
  // This is the recommended approach for production
  
  try {
    // Try to send via backend API first
    const formData = new FormData();
    formData.append('to', to);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('pdf', pdfBlob, pdfFileName);
    
    // Try to send email via backend
    // Update this URL to match your backend server (e.g., 'http://localhost:3001/api/send-email')
    const backendUrl = process.env.REACT_APP_EMAIL_API_URL || 'http://localhost:3001/api/send-email';
    
    try {
      const response = await fetch(backendUrl, {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        const result = await response.json();
        return { success: true, ...result };
      } else {
        throw new Error(`Backend responded with status: ${response.status}`);
      }
    } catch (backendError) {
      // If backend is not available, fall back to downloading PDF
      console.warn('Backend email service not available, downloading PDF instead:', backendError);
      
      // Download PDF as fallback
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = pdfFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      // Return success but indicate it was downloaded instead of sent
      return { 
        success: true, 
        downloaded: true,
        message: 'PDF downloaded. Email service not configured. Please set up backend or EmailJS.'
      };
    }
  } catch (error) {
    console.error('Email service error:', error);
    throw new Error('Failed to process email. Please check your email service configuration.');
  }
};

// Alternative implementation using EmailJS (uncomment and configure if using EmailJS)
/*
import emailjs from '@emailjs/browser';

export const sendEmail = async ({ to, subject, body, pdfBlob, pdfFileName }) => {
  try {
    // Convert blob to base64
    const reader = new FileReader();
    const base64Promise = new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(pdfBlob);
    });
    
    const base64 = await base64Promise;
    
    // Send email using EmailJS
    const result = await emailjs.send(
      'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
      'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
      {
        to_email: to,
        subject: subject,
        message: body,
        attachment: base64,
        attachment_name: pdfFileName
      },
      'YOUR_PUBLIC_KEY' // Replace with your EmailJS public key
    );
    
    return result;
  } catch (error) {
    console.error('EmailJS error:', error);
    throw new Error('Failed to send email via EmailJS');
  }
};
*/
